import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/carousel';
import Autoplay from 'embla-carousel-autoplay';
import { useRef } from 'react';

const mockups = [
  {
    src: '/images/mockup-dashboard.png',
    alt: 'Dashboard Principal - Visão Geral de Métricas SaaS',
    title: 'Dashboard Completo'
  },
  {
    src: '/images/mockup-integrations.png',
    alt: 'Integrações com Gateways de Pagamento',
    title: 'Integrações'
  },
  {
    src: '/images/mockup-reports.png',
    alt: 'Relatórios e Análises Detalhadas',
    title: 'Relatórios'
  },
  {
    src: '/images/mockup-import.png',
    alt: 'Importação de Dados em Massa',
    title: 'Importação de Dados'
  },
  {
    src: '/images/mockup-metrics.png',
    alt: 'Métricas Avançadas e Gráficos Detalhados',
    title: 'Métricas Avançadas'
  }
];

export function DashboardCarousel() {
  const plugin = useRef(
    Autoplay({ delay: 4000, stopOnInteraction: true })
  );

  return (
    <div className="relative mx-auto max-w-5xl">
      <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent z-10 pointer-events-none" />
      
      <Carousel
        plugins={[plugin.current]}
        className="w-full"
        onMouseEnter={plugin.current.stop}
        onMouseLeave={plugin.current.reset}
      >
        <CarouselContent>
          {mockups.map((mockup, index) => (
            <CarouselItem key={index}>
              <div className="rounded-lg border-2 bg-card p-2 shadow-2xl">
                <div className="relative aspect-video rounded overflow-hidden bg-muted">
                  <img
                    src={mockup.src}
                    alt={mockup.alt}
                    className="w-full h-full object-cover"
                    loading={index === 0 ? 'eager' : 'lazy'}
                  />
                  <div className="absolute bottom-4 left-4 bg-background/90 backdrop-blur px-3 py-1.5 rounded-md text-sm font-medium shadow-lg">
                    {mockup.title}
                  </div>
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
        
        <CarouselPrevious className="left-4" />
        <CarouselNext className="right-4" />
      </Carousel>

      {/* Indicators */}
      <div className="flex justify-center gap-2 mt-6">
        {mockups.map((_, index) => (
          <div
            key={index}
            className="h-2 w-2 rounded-full bg-muted hover:bg-primary/50 transition-colors"
            aria-label={`Slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
}
